import {useDispatch, useSelector} from "react-redux";
import {dialogs, hideActivateCollabDialog, extendedCollab, loading} from "../../../store/slice";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Button} from "@mui/material";
import {LocalSpinner} from "../../../../../../shared/components/Spinner";
import {ActivateUser} from "../../../store/actions";

export const ActivateUserDialog = () => {
    const dispatch = useDispatch();
    const {activateCollabDialog} = useSelector(dialogs);
    const collab = useSelector(extendedCollab);
    const {isLoadingActivateCollab} = useSelector(loading);

    const handleClose = () => {
        dispatch(hideActivateCollabDialog());
    };

    const handleActivateUser = () => {
        if(collab){
            dispatch(ActivateUser({id: collab.publicId}));
        }
    }

    return(
        <Dialog open={activateCollabDialog.isOpen} onClose={handleClose}>
            <DialogTitle>Activate user</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want activate this user?
                </DialogContentText>
            </DialogContent>
            {isLoadingActivateCollab ?
                <LocalSpinner />
                :
                <DialogActions>
                    <Button onClick={handleClose} color={'warning'}>Cancel</Button>
                    <Button onClick={handleActivateUser} disabled={!collab} color={'success'}>Activate</Button>
                </DialogActions>
            }
        </Dialog>
    )
}